import { Box } from '@mui/material'
import { memo } from 'react'

const TEXT_BLOCK_HEIGHT = 14

/** Structure-only placeholder for strategy builder payoff area shimmer. */
function StrategyPayoffSkeleton() {
    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%', width: '100%', minHeight: 0 }}>
            <Box sx={{ flex: 1, minHeight: 200, p: 2, display: 'flex', flexDirection: 'column', gap: 1 }}>
                <Box sx={{ height: TEXT_BLOCK_HEIGHT, width: 120 }} />
                <Box sx={{ flex: 1, minHeight: 160, width: '100%' }} />
            </Box>
            <Box sx={{ display: 'flex', gap: 1, px: 2, py: 1, height: 48, alignItems: 'center' }}>
                {[...Array(3)].map((_, i) => (
                    <Box key={i} sx={{ height: TEXT_BLOCK_HEIGHT, width: 72 + (i % 2) * 16, borderRadius: 0.5 }} />
                ))}
            </Box>
        </Box>
    )
}

export default memo(StrategyPayoffSkeleton)
